import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
} from "firebase/firestore";

import { db } from "../apis/auth";

export async function GetDailyReportQuery(startDate, endDate, zone = 0, ward = 0, devId = null) {
    console.log(`===== ReportQuery : GetDailyReportQuery(date=${startDate}, zone=${zone}, ward=${ward}, devId=${devId}) ========`);
    return new Promise(function (resolve, reject) {
        var reportQuery = query(
            collection(db(), "daily_summ"),
            where("dt", ">=", startDate),
            where("dt", "<=", endDate));
        if (zone !== 0) {
            reportQuery = query(
                reportQuery,
                where("zn", "==", zone));

            if (ward !== 0) {
                reportQuery = query(
                    reportQuery,
                    where("wd", "==", ward));
            }
        }

        if (devId !== 0) {
            reportQuery = query(
                reportQuery,
                where("dev_id", "==", devId));
        }

        reportQuery = query(
            reportQuery,
            orderBy("dt", "asc"));

        getDocs(reportQuery).then((querySnapshot) => {
            resolve(querySnapshot);
        }).catch((error) => {
            console.log(`====> Error fetch : ${error}`);
            reject(error);
        });
    });

}

export async function GetLampReportQuery(startDate, endDate, zone = 0, ward = 0) {
    return new Promise(function (resolve, reject) {
        var reportQuery = query(
            collection(db(), "LmpSt"),
            where("dt", ">=", startDate),
            where("dt", "<=", endDate));
        if (zone !== 0) {
            reportQuery = query(
                reportQuery,
                where("zn", "==", zone));

            if (ward !== 0) {
                reportQuery = query(
                    reportQuery,
                    where("wd", "==", ward));
            }
        }

        reportQuery = query(
            reportQuery,
            orderBy("dt", "asc"));

        getDocs(reportQuery).then((querySnapshot) => {
            resolve(querySnapshot);
        }).catch((error) => {
            console.log(`====> Error fetch : ${error}`);
            reject(error);
        });
    });

}